<script>

export default {
  name: "ChatFilePreviewModal",
  props: {
    files: { type: Array, default: () => [] },
    value: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      caption: this.value
    };
  },
  watch: {
    value(newVal) { this.caption = newVal; },
    caption(newVal) { this.$emit('input', newVal); }
  },
  methods: {
    show() { this.visible = true; },
    hide() { this.visible = false; },
    handleClose() { this.visible = false; },
    isImage(file) {
      return file.type.startsWith('image/');
    },
    getFileUrl(file) {
      return URL.createObjectURL(file);
    },
    removeFile(index) {
      const updatedFiles = [...this.files];
      updatedFiles.splice(index, 1);
      this.$emit('files-updated', updatedFiles);
      if (updatedFiles.length === 0) {
        this.hide();
      }
    },
    handleSend() {
      this.$emit('send-files', { files: this.files, caption: this.caption });
      this.hide();
    },
  }
}
</script>

<template>
  <div class="quotation-chat-preview-modal">

    <el-dialog
      title="Надіслати файли"
      :visible.sync="visible"
      :before-close="handleClose"
      custom-class="chat-preview-modal"
    >
      <div class="preview-grid">
        <div v-for="(file, index) in files" :key="index" class="preview-card">
          <img v-if="isImage(file)" :src="getFileUrl(file)" class="img-thumb" />
          <div v-else class="file-icon-placeholder">📄</div>
          <span class="file-name">{{ file.name }}</span>
          <i class="el-icon-error delete-btn" @click="removeFile(index)"></i>
        </div>
      </div>

      <div class="mt-4">
        <el-input type="textarea" v-model="caption" placeholder="Додати підпис..." />
      </div>

<!--      <div class="preview-files-list">-->
<!--        <div v-for="(file, index) in files" :key="index" class="preview-file-item">-->
<!--          <span class="file-name">{{ file.name }}</span>-->
<!--          <i class="el-icon-close remove-icon" @click="removeFile(index)"></i>-->
<!--        </div>-->
<!--      </div>-->

      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Скасувати</el-button>
        <el-button type="primary" class="send-preview-image" @click="handleSend" :disabled="files.length === 0">Надіслати</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

</style>
<style lang="scss">
@import "./../styles/quotation-modal.scss";
</style>

